import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { PaymentMethodOptions } from '../types/payments';
import { selectQuote } from './selectQuote';

export const selectPayments = (state: RootState) => state.payments;
export const selectPaymentData = createSelector(
  selectPayments,
  selectQuote,
  (state: RootState) => state.payMyBill,
  (
    {
      paymentMethod,
      paymentFrequency,
      creditCardNumberMasked,
      creditCardType,
      creditCardExpiryDate,
      cybersourceToken,
      bankAccountNumber,
      bankAccountBsb,
      bankAccountName,
      creditCardName,
      transientToken,
    },
    { premiums },
    payMyBill
  ) => ({
    /** @clarify which fields here are mandatory and what validations/rules are applied per method/frequency */

    paymentMethod: paymentMethod!,
    paymentPeriod: paymentFrequency!,
    ...(paymentMethod === PaymentMethodOptions.CreditCard
      ? {
          creditCardNumber: creditCardNumberMasked || '',
          tokenizedCreditCardNumber: cybersourceToken || '',
          creditCardType: creditCardType || '',
          creditCardExpiry: creditCardExpiryDate ?? '',
          transientToken: transientToken || '',
        }
      : {
          accountNumber: bankAccountNumber ? String(bankAccountNumber) : '',
          bsb: bankAccountBsb ? String(bankAccountBsb) : '',
        }),

    accountName: bankAccountName || creditCardName || '',

    ...(premiums?.policy?.policyPremium?.transactionPremium?.totalPremium && {
      totalPremiumPaid: premiums?.policy?.policyPremium?.transactionPremium?.totalPremium,
    }),
    ...(payMyBill.policy?.dueAmount && {
      totalPremiumPaid: payMyBill.policy?.dueAmount,
    }),
  })
);
